import { render } from "./HFargudit.vue?vue&type=template&id=1a4e1674&scoped=true"
import script from "./HFargudit.vue?vue&type=script&lang=js"
export * from "./HFargudit.vue?vue&type=script&lang=js"

import "./HFargudit.vue?vue&type=style&index=0&id=1a4e1674&lang=scss&scoped=true"
import "./HFargudit.vue?vue&type=style&index=1&id=1a4e1674&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4e1674"]])

export default __exports__